import { render } from "./ManualCharges.vue?vue&type=template&id=a9fcce12&scoped=true&ts=true"
import script from "./ManualCharges.vue?vue&type=script&lang=ts"
export * from "./ManualCharges.vue?vue&type=script&lang=ts"

import "./ManualCharges.vue?vue&type=style&index=0&id=a9fcce12&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9fcce12"]])

export default __exports__